module.exports = __webpack_public_path__ + "img/cblr1.e78a8f87.gif";